module.exports = __webpack_public_path__ + "static/media/mp.7cda8917.png";